import { reportErrorToNewRelic } from '@/external_scripts/newrelic'
import { translate } from '@/plugins/i18n.js'

class MessageHelper {
  constructor() {
    if (MessageHelper.Singleton) return

    MessageHelper.Singleton = this
  }

  async addMessage(
    message,
    icon = 'icon_svg_info',
    link = null,
    expiration = 5000
  ) {
    try {
      const { flashMessenger } = await _getModules()
      await flashMessenger.addMessage({
        expiration: expiration,
        message: translate(message),
        icon,
        link
      })
    } catch (r) {
      console.error(r)
    }
  }

  /**
   * @param {string} message
   * @param {string|null} link
   * @param {number} expiration
   * @param {Error|null} error - When present, sent to New Relic (and console). Ensures errors are tracked.
   * @param {string|null} [source] - Optional NR source for segmentation (e.g. 'checkout_opc', 'auth_register').
   */
  addErrorMessage(
    message,
    link = null,
    expiration = 5000,
    error = null,
    source = null
  ) {
    if (error) {
      console.error(message, error)
      reportErrorToNewRelic(error, { source: source || 'message_helper' })
    } else {
      console.error(message)
    }
    void this.addMessage(message, 'icon_svg_alert', link, expiration)
  }

  async destroyMessage() {
    try {
      const { flashMessenger } = await _getModules()
      await flashMessenger.removeMessage()
    } catch (r) {
      console.error(r)
    }
  }
}

const _getModules = (() => {
  let cache

  return async () => {
    if (cache) return cache

    const [{ useFlashMessengerStore }] = await Promise.all([
      await import('@/stores/flashMessenger')
    ])
    cache = { flashMessenger: useFlashMessengerStore() }
    return cache
  }
})()

export default new MessageHelper()
